import { createFileRoute } from '@tanstack/react-router';

import { LinksPage } from '@/links/pages/links';
import { requireAuth } from '@/shared/auth';

export const Route = createFileRoute('/links/')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  component: LinksRoute
});

function LinksRoute() {
  return <LinksPage />;
}
